// Greedy interval packing — ported verbatim from gantt-board.jsx (typed).
// Assigns each entry a sub-row so overlapping runs never visually collide; the
// lane height grows to fit. Drives both the track and the rail-cell height.

export interface PackInput {
  absStart: number;
  absEnd: number;
}

export interface PackedItem<T extends PackInput> {
  e: T;
  row: number;
}

export interface PackResult<T extends PackInput> {
  items: PackedItem<T>[];
  rows: number;
}

export function packRows<T extends PackInput>(list: T[]): PackResult<T> {
  const s = [...list].sort((a, b) => a.absStart - b.absStart || a.absEnd - b.absEnd);
  const rowEnds: number[] = [];
  const items = s.map((e) => {
    let r = rowEnds.findIndex((end) => end <= e.absStart);
    if (r === -1) {
      r = rowEnds.length;
      rowEnds.push(e.absEnd);
    } else {
      rowEnds[r] = e.absEnd;
    }
    return { e, row: r };
  });
  return { items, rows: Math.max(1, rowEnds.length) };
}
